import styled, { css } from 'styled-components';

export const Banner = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    gap: ${theme.sz.s3};
    width: 100%;
    padding: ${theme.sz.s3} ${theme.sz.s4};
    border: ${theme.bo.mediumWidth} solid ${theme.co.primary40};
    border-radius: ${theme.bo.medium};
    background-color: ${theme.co.primary95};
  `,
);

export const Check = styled.span(
  ({ theme }) => css`
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    width: ${theme.sz.s7};
    height: ${theme.sz.s7};
    border-radius: ${theme.bo.elliptical};
    background-color: ${theme.co.neutral99};
    color: ${theme.co.neutral10};
    font-size: ${theme.sz.s4};
  `,
);

export const Text = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.m};
    margin: 0;
    color: ${theme.co.neutral30};
  `,
);

export const Title = styled.strong(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxxs};
    color: ${theme.co.neutral10};
  `,
);
